import { useLayoutEffect, useRef } from 'react';
import { Routes, Route } from 'react-router-dom';

import { useTheme } from '@pray/shared/contexts';

import AudiobookPage from './pages/audiobooks/AudiobookPage';
import ContentManagementPage from './pages/cms/ContentManagementPage';
import CustomerManagementPage from './pages/crm/CustomerManagementPage';
import MinistryInsightsPage from './pages/ministry-insights/MinistryInsightsPage';
import SocialClipsPage from './pages/social-clips/SocialClipsPage';
import TranslationsPage from './pages/translations/TranslationsPage';
import WorkflowAIPage from './pages/workflow-ai/WorkflowAIPage';
import Footer from '../../components/Footer/Footer';

export default function ProductsPage() {
  const { theme, setColorMode } = useTheme();

  // Product pages are designed for dark mode. Drive the global ThemeProvider to
  // dark on mount and restore whatever color mode was active on unmount. Mutating
  // body classes directly no longer works: the provider's MutationObserver reverts
  // them. Restoring the previous mode (instead of hard-setting light) avoids
  // clobbering a user's chosen mode when leaving these pages.
  const previousColorMode = useRef(theme.colorMode);
  useLayoutEffect(() => {
    setColorMode('dark');
    return () => setColorMode(previousColorMode.current);
  }, [setColorMode]);

  return (
    <>
      <Routes>
        <Route path="social-clips" element={<SocialClipsPage />} />
        <Route path="ai-translations" element={<TranslationsPage />} />
        <Route path="ai-audiobooks" element={<AudiobookPage />} />
        <Route path="workflow-ai" element={<WorkflowAIPage />} />
        <Route path="crm" element={<CustomerManagementPage />} />
        <Route path="ministry-insights" element={<MinistryInsightsPage />} />
        <Route path="cms" element={<ContentManagementPage />} />
      </Routes>
      <Footer />
    </>
  );
}
